// extracted by mini-css-extract-plugin
export default {"results-container":"SIG9H08oaJZBhzn8Wvr4","results-column":"uEMahMREAICzeZd_Yf8E","box-push":"H3TP9JUqe7IGlngqWqmn","box-push-collection":"V32uMjPFRg4FcYosQ68_"};